import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-6153" />
      <ArchitectureDiagram data-id="element-6154" />
      <HowItWorksConnections mode="how" data-id="element-6155" />
      <LivesInSlack data-id="element-6156" />
      <ComputerUse data-id="element-6157" />
      <CapabilityGrid data-id="element-6158" />
      <NarrativeSection data-id="element-6159" />
      <ToolComparison data-id="element-6160" />
      <WallOfLove data-id="element-6161" />
      <PricingSection data-id="element-6162" />
      <ClosingCTA data-id="element-6163" />
    </>;
}